import Repository from "../Repository";

const resource = "/customers";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getCustomer(customerId){
        return Repository.get(`${resource}/${customerId}`);
    },
    createCustomer(json){
        return Repository.post(`${resource}`,json);
    },
    updateCustomer(customerId,json){
        return Repository.put(`${resource}/${customerId}`,json);
    },
    deleteCustomer(customerId){
        return Repository.delete(`${resource}/${customerId}`);
    }
}